import { analytics } from '../../utils/analytics';
import { getCustomerIdFromToken } from '../../utils/getCustomerIdFromToken';
import { post } from '../apiService';
type response = {
  status: string;
  practiceId?: string;
};

export const createPractice = async (
  body?: object
): Promise<{
  data: response;
  loading: boolean;
}> => {
  const customer = getCustomerIdFromToken();
  if (!customer) {
    throw new Error('Customer Id is not available');
  }
  if (!body) {
    throw new Error('Body is not available');
  }
  const url = `resourceMatrix/practices/create?customerId=${customer}`;
  let loading = true;
  try {
    const responseData = await post(
      url,
      body as Record<string, unknown>,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    const data = responseData as response;
    loading = false;
    analytics.trackEvent('create', 'practice');
    return { data, loading };
  } catch (error) {
    loading = false;
    throw new Error('Failed to create practice item');
  }
};
